const colors = require("../../src/styles/colors");

module.exports = {
  siteTitle: "Project Surf Helmet", // <title>
  shortSiteTitle: "Surf helmet", // <title> ending for posts and pages
  siteDescription: "Uncovering the best surf helmets.  Detailed surf helmet reviews that consider impact protection and surfing performance.  All helmets tried and tested.  All applicable helmet technologies researched and referenced.  There's no better resource on the internet comparing what's available now and what could be, gauranteed.  If you're looking for the right surf helmet, you've found the right place.",
  siteUrl: "https://projectsurfhelmet.com",
  pathPrefix: "",
  siteImage: "https://res.cloudinary.com/dx1tmklnq/image/upload/v1562885190/project_surf_helmet/surf_helmet_concept_dppyyp.jpg",
  siteLanguage: "en",
  // author
  authorName: "Cole Merrick",
  authorTwitterAccount: "colemerrick",
  // info
  infoTitle: "PSH",
  infoTitleNote: "",
  // manifest.json
  manifestName: "Finding highly protective surf helmets that perform well",
  manifestShortName: "Project Surf Helmet", // max 12 characters
  manifestStartUrl: "/",
  manifestBackgroundColor: colors.background,
  manifestThemeColor: colors.background,
  manifestDisplay: "standalone",
  // contact
  contactEmail: "cole@projectsurfhelmet.com",
  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/colemerrick" },
    { name: "twitter", url: "https://twitter.com/colemerrick" },
    { name: "facebook", url: "https://facebook.com/colemerrick1" }
  ]
};



// WEBPACK FOOTER //
// ./content/meta/config.js